import { v4 as uuidv4 } from 'uuid';
import { create } from 'zustand';

import { AddJobProps } from './types';

type UUID = string;

export interface ISyncQueueJob {
  id: UUID;
  createdAt: Date;
  data: AddJobProps;
  // method: SyncQueueJobMethod;
  // collections: Array<SyncCollection>;
}
export interface ISyncQueueStore {
  jobs: ISyncQueueJob[];
  addJob: (job: AddJobProps) => void;
  removeJob: (jobId: UUID) => void;
  clear: () => void;
}

export const useSyncQueueStore = create<ISyncQueueStore>((set) => ({
  jobs: [],
  // eslint-disable-next-line sonarjs/cognitive-complexity
  addJob: (job: AddJobProps): void => {
    set((state) => {
      const newJob: ISyncQueueJob = {
        id: uuidv4(),
        createdAt: new Date(),
        data: job,
      };

      return {
        jobs: [...state.jobs, newJob],
      };
    });
  },
  removeJob: (jobId: UUID) => {
    set((state) => {
      const filteredJobs = state.jobs.filter((iJob) => iJob.id !== jobId);
      return { jobs: filteredJobs };
    });
  },
  clear: () => set({ jobs: [] }),
}));
